module.exports = __webpack_public_path__ + "static/media/signature.d2a3cd0d.png";